import React, { useState, useEffect } from 'react';

const Tabla_aclimatacion_vivero_campo = (p) => {

    useEffect(() => {

    }, []);

    const numberFormat = (number) => {
        try {
            let format = parseFloat(number);
            if (isNaN(format)) return 0;
            return format;
        } catch (error) {
            return 0;
        }
    }
    const diaslow = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

    const dias_sembrados = (dt) => {
        let count = [];
        for (let i = 0; i < diaslow.length; i++) {
            let d = diaslow[i] + '_ejecutado';
            if (numberFormat(dt[d]) > 0) count.push(i + 1);
        }

        return count.join(', ');
    }

    const total_ejecutado = (dt) => {
        let total = 0;
        for (let i = 0; i < dias.length; i++) {
            total += dt[`${dias[i]}e`];
        }
        return total;
    }

    return (
        <table className='table table-sm table-hover table-bordered dosis trxt-m'>
            <thead>
                <tr className='nowrap'>
                    <th className='text-start ps-2 bg-white-gradient-left stick-col'></th>
                    <th className='text-start ps-2 bg-white-gradient-left stick-col' style={{ minWidth: '100px' }}>Flor varidad color</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Sem. Aclimatación</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Sem. corte</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Presupuesto</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Sem. siembra</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Día(s) siembra</th>
                    <th className='text-center' style={{ minWidth: '80px' }}># Charolas</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>CV. Charolas</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>GM. consolidación</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Plantas reales</th>
                    <th className='text-center' style={{ minWidth: '80px' }}>Diferencia Real - PPTO</th>
                    <th className='text-start ps-2 bg-white-gradient-left stick-col'></th>
                </tr>
            </thead>
            <tbody>
                {
                    p.data.map((dt, i) =>
                        <tr key={'datarr ' + i} className={`nowrap relative ${dt.concluido === 1 ? 'opacity-40 text-bold' : ''}`} >
                            <th className={'text-xs stick-col contenedor' + (dt.concluido === 1 ? ' text-danger' : '')}>{i + 1}</th>
                            <th className={'text-m stick-col ' + (dt.concluido === 1 ? ' text-danger' : '')}>{dt.bloque}</th>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>{dt.semana_actual}</td>
                            <td className={'text-m text-center text-bold' + (dt.concluido === 1 ? ' text-danger' : '')}>{dt.semanaCosecha}</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>{Math.floor(numberFormat(dt.plantas))}</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>{dt.semana_siembra}</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>{dias_sembrados(dt)}</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>{Math.floor(numberFormat(dt.charolas_cosolidadas ?? 0))}</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>288</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 || numberFormat(dt.germinacion_consolidacion) === 0 ? ' text-danger' : '')}>{dt.germinacion_consolidacion}</td>
                            <td className={'text-m text-center' + (dt.concluido === 1 ? ' text-danger' : '')}>{Math.floor(numberFormat(dt.plantas_reales ?? 0))}</td>
                            <td className={'text-m text-center ' + (((dt.plantas_reales ?? 0) - (dt.plantas ?? 0)) >= 0 ? '' : 'text-red3 text-bold')}>{Math.floor(numberFormat((dt.plantas_reales ?? 0) - (dt.plantas ?? 0)))}</td>
                            <td className='text-m text-center'>
                                <button className={'btn btn-sm pt-0 pb-0 ' + (dt.aclimatado ? "btn-warning shadow-sm text-bold ps-5 pe-5" : "btn-light shadow  ps-5 pe-5")}
                                    onClick={() => { p.check(i, 'aclimatacion') }}
                                    disabled={total_ejecutado(dt) <= 0 || dt.concluido === 1 || numberFormat(dt.germinacion_real) === 0 || numberFormat(dt.germinacion_consolidacion) === 0}
                                >{dt.aclimatado ? "Listo" : "No"}</button>
                            </td>
                        </tr>
                    )
                }

            </tbody>
        </table>
    )
}

export default Tabla_aclimatacion_vivero_campo;